import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { ArticleDetail, DocumentDetail, EventDetail } from "@/lib/types";

/** GET /api/v1/documents/<id>/ — full shape with description + tags + owner. */
export function useDocument(id: string | undefined) {
  return useQuery<DocumentDetail>({
    enabled: id != null && !Number.isNaN(id),
    queryKey: ["documents", "detail", id],
    queryFn: async () => {
      const { data } = await api.get<DocumentDetail>(`/documents/${id}/`);
      return data;
    },
  });
}

/** GET /api/v1/articles/<slug>/ — full shape with content body + owner. */
export function useArticle(slug: string | undefined) {
  return useQuery<ArticleDetail>({
    enabled: !!slug,
    queryKey: ["articles", "detail", slug],
    queryFn: async () => {
      const { data } = await api.get<ArticleDetail>(`/articles/${slug}/`);
      return data;
    },
  });
}

/** GET /api/v1/events/<id>/ — full shape with description + owner. */
export function useEvent(id: string | undefined) {
  return useQuery<EventDetail>({
    enabled: id != null && !Number.isNaN(id),
    queryKey: ["events", "detail", id],
    queryFn: async () => {
      const { data } = await api.get<EventDetail>(`/events/${id}/`);
      return data;
    },
  });
}
